import * as types from './types';
import * as constants from './constants'
import service from '@/api/CommonService'
import notificationService from '@/api/NotificationService'
import authService from '@/api/AuthService'
import router from '@/router'
import store from '@/store'

export default {

    [types.ACTION_TOTAL_ROWS]: ({commit}, payload) => {
        notificationService.fetchTotalRows().then( (response) => {
            commit(types.MUTATE_TOTAL_ROWS, response.data, {root: true})
        })
    },

    [types.ACTION_TOTAL_ROWS_AGENCY]: ({commit}, payload) => {
        notificationService.fetchTotalRowsByAgency(payload).then( (response) => {
            commit(types.MUTATE_TOTAL_ROWS, response.data, {root: true})
        })
    },

	[types.ACTION_FIND_AGENCIES]: ({commit}, payload) => {
    	service.getAgencies(payload).then( (response) => {
    		commit(types.MUTATE_AGENCIES, response.data, {root: true})
    	})
    },    
    [types.ACTION_ADD_AGENCY]: ({commit}, payload) => {
        service.addAgency(payload).then( (response) => { 
            store.dispatch(types.ACTION_FIND_AGENCIES)
        })
    },    
    [types.ACTION_FIND_PURPOSES]: ({commit}, payload) => {
    	service.getPurposes(payload).then( (response) => {
    		commit(types.MUTATE_PURPOSES, response.data, {root: true})
    	})
    },
    [types.ACTION_FIND_REQUEST_TYPES]: ({commit}, payload) => {
    	service.getRequestTypes(payload).then( (response) => {
    		commit(types.MUTATE_REQUEST_TYPES, response.data, {root: true})
    	})
    },
    [types.ACTION_FIND_EMERGENCY_NOTIFICATION]: ({commit}, payload) => {
        service.getEmergencyNotification(payload).then( (response) => {
            commit(types.MUTATE_EMERGENCY_NOTIFICATION, response.data, {root: true})
        })
    },
    [types.ACTION_FIND_STATUSES]: ({commit}, payload) => {
        service.getStatuses(payload).then( (response) => {
            commit(types.MUTATE_STATUSES, response.data, {root: true})
        })
    },
    [types.ACTION_FIND_STATUS_BY_ID]: ({commit}, param) => {
        service.getStatusById(param).then( (response) => {
            commit(types.MUTATE_STATUSES, response.data, {root: true})
        })
    },
    [types.ACTION_FIND_AIR_USAGE]: ({commit}, payload) => {
        service.getAirTypeById(payload).then( (response) => {
        
            if (payload === constants.AIR_TYPE_CLEARANCE)
                commit(types.MUTATE_AIR_CLEARANCE, response.data)
            else if (payload === constants.AIR_TYPE_USAGE)
                commit(types.MUTATE_AIR_USAGE, response.data)
            else if (payload === constants.AIR_TYPE_REQUEST)
                commit(types.MUTATE_AIR_REQUEST, response.data)
            else if (payload === constants.AIR_TYPE_OPERATOR)
                commit(types.MUTATE_AIR_OPERATOR, response.data)
        }) 
    },
    // [types.ACTION_FIND_AIR]: ({commit}, payload) => {
    //     service.fetchByNotificationId(payload).then( (response) =>   {
    //         commit(types.MUTATE_AIR, response.data)
    //     })
    // },
    [types.ACTION_FIND_NSL_FACILITY_TYPE]: ({commit}, payload) => {
        service.getFacilityType(payload).then( (response) =>   {
            commit(types.MUTATE_NSL_FACILITY_TYPE, response.data)
        })
    },
    [types.ACTION_FIND_NSL_SITE_TYPE]: ({commit}, payload) => {
        service.getSiteType(payload).then( (response) =>   {
            commit(types.MUTATE_NSL_SITE_TYPE, response.data)
        })
    },
    [types.ACTION_AUTH_USER]: ({commit}, payload) => {
        authService.login(payload)
            .then( (response) => {
                if (response) {
                    // commit(types.MUTATE_USER_ID, response.id)
                    // commit(types.MUTATE_USERNAME, response.username)
                    // commit(types.MUTATE_USER_FIRSTNAME, response.firstname)
                    // commit(types.MUTATE_USER_LASTNAME, response.lastname)
                    commit(types.MUTATE_USER_TOKEN, response.token)
                    
                    //window.localStorage.setItem('token', JSON.stringify(response.token));
                    
                    // commit(types.MUTATE_USER_PERMISSION, response.permission)
                    // commit(types.MUTATE_USER_AGENCY_ID, response.agency_id)
                    // commit(types.MUTATE_USER_AGENCY_NAME, response.agency_name)

                    // load common table
                    store.dispatch(types.ACTION_FIND_AGENCIES)
                    store.dispatch(types.ACTION_FIND_REQUEST_TYPES)
                    store.dispatch(types.ACTION_FIND_STATUSES)
                    store.dispatch(types.ACTION_FIND_NSL_FACILITY_TYPE)
                    store.dispatch(types.ACTION_FIND_NSL_SITE_TYPE)

                    // get user info
                    store.dispatch(types.ACTION_FIND_USER_BY_USERNAME, payload.username)
                    
                    // if (response.permission === constants.ADMIN)
                    //     router.replace('/home')
                    // else 
                    //     router.replace('/home-user')
                }                
            })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js